'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadCmsPageError = exports.loadCmsPage = exports.LOAD_CMS_PAGE_ERROR = exports.LOAD_CMS_PAGE = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.trackUserData = trackUserData;
exports.doRedirectUser = doRedirectUser;
exports.doInitializeMsa = doInitializeMsa;
exports.doLoadCmsPage = doLoadCmsPage;
exports.watchCmsPageSagas = watchCmsPageSagas;

var _reactRouterRedux = require('react-router-redux');

var _sagaTools = require('@classpass/saga-tools');

var _effects = require('redux-saga/effects');

var _homepage = require('redux/modules/features/homepage');

var _helpers = require('redux/saga/helpers');

var _localStorage = require('redux/saga/helpers/local-storage');

var _msas = require('redux/saga/helpers/msas');

var _bound = require('redux/saga/entities/bound');

var _selectors = require('redux/saga/selectors');

var _memberStatus = require('enums/memberStatus');

var _deep = require('helpers/deep');

var _multitrack = require('helpers/multitrack');

var _GoogleTagManager = require('components/GoogleTagManager/GoogleTagManager');

var _cmsModules = require('./cms-modules.saga');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(trackUserData),
    _marked2 = /*#__PURE__*/_regenerator2.default.mark(doRedirectUser),
    _marked3 = /*#__PURE__*/_regenerator2.default.mark(doInitializeMsa),
    _marked4 = /*#__PURE__*/_regenerator2.default.mark(doLoadCmsPage),
    _marked5 = /*#__PURE__*/_regenerator2.default.mark(watchCmsPageSagas);

var LOAD_CMS_PAGE = exports.LOAD_CMS_PAGE = 'LOAD_CMS_PAGE';
var LOAD_CMS_PAGE_ERROR = exports.LOAD_CMS_PAGE_ERROR = 'LOAD_CMS_PAGE_ERROR';

var loadCmsPage = exports.loadCmsPage = function loadCmsPage(path) {
  return { type: LOAD_CMS_PAGE, path: path };
};
var loadCmsPageError = exports.loadCmsPageError = _helpers.errorActionCreator.bind(null, LOAD_CMS_PAGE_ERROR);

function trackUserData(client, msaId, msaAlias, user) {
  var isCartAbandonner;
  return _regenerator2.default.wrap(function trackUserData$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          isCartAbandonner = (0, _memberStatus.memberStatus)('UNSUBSCRIBED', (0, _deep.deepExtract)('membership.status', user));
          _context.next = 4;
          return (0, _effects.call)(_GoogleTagManager.trackGoogleTagManagerEvent, {
            msaId: msaId,
            msaName: msaAlias,
            userId: isCartAbandonner && user.id
          });

        case 4:
          _context.next = 8;
          break;

        case 6:
          _context.prev = 6;
          _context.t0 = _context['catch'](0);

        case 8:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this, [[0, 6]]);
}

function doRedirectUser(status) {
  return _regenerator2.default.wrap(function doRedirectUser$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          if (!(status === 'active' || status === 'unpaid')) {
            _context2.next = 7;
            break;
          }

          if (!(__CLIENT__ && !__TEST__)) {
            _context2.next = 4;
            break;
          }

          window.location.href = '/search';
          return _context2.abrupt('return');

        case 4:
          _context2.next = 6;
          return (0, _effects.put)((0, _reactRouterRedux.push)('/search'));

        case 6:
          return _context2.abrupt('return', _context2.sent);

        case 7:
          if (!(status === 'unsubscribed')) {
            _context2.next = 11;
            break;
          }

          _context2.next = 10;
          return (0, _effects.put)((0, _reactRouterRedux.push)('/signup/continue'));

        case 10:
          return _context2.abrupt('return', _context2.sent);

        case 11:
          if (!(status === 'cancelled')) {
            _context2.next = 15;
            break;
          }

          _context2.next = 14;
          return (0, _effects.put)((0, _reactRouterRedux.push)('/rejoin'));

        case 14:
          return _context2.abrupt('return', _context2.sent);

        case 15:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}

function doInitializeMsa(client, path) {
  var msa;
  return _regenerator2.default.wrap(function doInitializeMsa$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return (0, _effects.call)(_msas.getMsaFromPath, client, path);

        case 2:
          _context3.t1 = _context3.sent;

          if (_context3.t1) {
            _context3.next = 7;
            break;
          }

          _context3.next = 6;
          return (0, _effects.call)(_helpers.geodetectMsa, client);

        case 6:
          _context3.t1 = _context3.sent;

        case 7:
          _context3.t0 = _context3.t1;

          if (_context3.t0) {
            _context3.next = 10;
            break;
          }

          _context3.t0 = {};

        case 10:
          msa = _context3.t0;

          if (!msa.package_purchase) {
            _context3.next = 16;
            break;
          }

          _context3.next = 14;
          return (0, _effects.put)((0, _homepage.setMsaId)(msa.id));

        case 14:
          _context3.next = 19;
          break;

        case 16:
          if (!['/homepage', '/rejoin', '/try'].includes(path)) {
            _context3.next = 19;
            break;
          }

          _context3.next = 19;
          return (0, _effects.call)(_multitrack.ga, 'Geodetection', 'Not geodetected', null, null, { nonInteraction: true });

        case 19:
          return _context3.abrupt('return', msa);

        case 20:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked3, this);
}

function doLoadCmsPage(client, _ref) {
  var path = _ref.path;

  var msa, msaId, msaAlias, cmsData, profile, status, audience, shouldSeePage, _ref2, _ref3, redirectTo;

  return _regenerator2.default.wrap(function doLoadCmsPage$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.prev = 0;
          _context4.next = 3;
          return (0, _effects.call)(doInitializeMsa, client, path);

        case 3:
          msa = _context4.sent;
          msaId = msa.id;
          msaAlias = msa.alias;
          _context4.next = 8;
          return (0, _effects.call)(_sagaTools.fetchEntityIfNeeded, _bound.cms, [client, path, (0, _extends3.default)({}, msaAlias && msa.package_purchase && { msa_alias: msaAlias })]);

        case 8:
          cmsData = _context4.sent;

          if (!(__CLIENT__ && cmsData.metadata.cpOptimize)) {
            _context4.next = 17;
            break;
          }

          _context4.prev = 10;
          _context4.next = 13;
          return (0, _effects.call)(_localStorage.writeSessionStorage, 'cpOptimize', cmsData.metadata.cpOptimize);

        case 13:
          _context4.next = 17;
          break;

        case 15:
          _context4.prev = 15;
          _context4.t0 = _context4['catch'](10);

        case 17:
          _context4.next = 19;
          return (0, _effects.select)(_selectors.isLoggedIn);

        case 19:
          if (!_context4.sent) {
            _context4.next = 25;
            break;
          }

          _context4.next = 22;
          return (0, _effects.call)(_sagaTools.fetchEntityIfNeeded, _bound.userProfile, [client]);

        case 22:
          _context4.t1 = _context4.sent;
          _context4.next = 26;
          break;

        case 25:
          _context4.t1 = null;

        case 26:
          profile = _context4.t1;

          if (!profile) {
            _context4.next = 35;
            break;
          }

          status = (0, _deep.deepExtract)('membership.status', profile);
          audience = cmsData.metadata.audience || [];
          shouldSeePage = audience.indexOf(status) !== -1;

          if (shouldSeePage) {
            _context4.next = 35;
            break;
          }

          _context4.next = 34;
          return (0, _effects.call)(doRedirectUser, status);

        case 34:
          return _context4.abrupt('return');

        case 35:
          _context4.next = 37;
          return (0, _effects.spawn)(trackUserData, client, msaId, msaAlias, profile);

        case 37:
          _context4.next = 39;
          return (0, _effects.call)(_cmsModules.doLoadCmsModules, client, cmsData);

        case 39:
          _context4.next = 41;
          return (0, _effects.call)(_helpers.scrollToTop);

        case 41:
          return _context4.abrupt('return', cmsData);

        case 44:
          _context4.prev = 44;
          _context4.t2 = _context4['catch'](0);

          if (!(_context4.t2 && _context4.t2.httpStatus === 404)) {
            _context4.next = 52;
            break;
          }

          _ref2 = [['/try/', '/try'], ['/rejoin/', '/rejoin']].find(function (_ref4) {
            var _ref5 = (0, _slicedToArray3.default)(_ref4, 1),
                pathPrefix = _ref5[0];

            return path.indexOf(pathPrefix) === 0;
          }) || [], _ref3 = (0, _slicedToArray3.default)(_ref2, 2), redirectTo = _ref3[1];

          if (!redirectTo) {
            _context4.next = 52;
            break;
          }

          _context4.next = 51;
          return (0, _effects.put)((0, _reactRouterRedux.replace)({
            pathname: redirectTo,
            state: { status: 301 }
          }));

        case 51:
          return _context4.abrupt('return', _context4.sent);

        case 52:
          _context4.next = 54;
          return (0, _effects.put)(loadCmsPageError(_context4.t2));

        case 54:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked4, this, [[0, 44], [10, 15]]);
}

function watchCmsPageSagas(client) {
  return _regenerator2.default.wrap(function watchCmsPageSagas$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return (0, _effects.fork)(_effects.takeEvery, LOAD_CMS_PAGE, doLoadCmsPage, client);

        case 2:
        case 'end':
          return _context5.stop();
      }
    }
  }, _marked5, this);
}